import React from 'react';
import { Container, Image, Row, Col } from 'react-bootstrap';
import MoonozC from '../img/MoonozCollege2.jpg';
import Moonoz from '../img/moonozPic.jpg';
import Banner from '../img/MoonBanner.jpg';

function aboutMe() {
    return (

        <Container className="No-Left-Right" fluid>


            <Image src={Banner} className="about-Me-Banner" fluid />
            <Container className="sec-padding" fluid>
                <Row>
                    <Col className="m-auto" md>
                        <Image src={MoonozC} className="about-Me-Moonoz d-block mx-auto" />

                    </Col>
                    <Col className="sec-Text margin-auto align-items-center text-padding-right" md>
                        <h1 >
                            Hey, I'm Joel Munoz
                        </h1>

                        <p class="about-Me-Text">
                        I'm a first Generation Mexican American College Graduate and a <strong>Delinquent Dreamer</strong> (<i>Those who refuse to believe it’s a crime to follow their Dreams</i>). My Dream has always been to work with my creative mind (<i>and Pixar</i>). In 2019 I Graduated From California University East Bay with a Bachelors in Computer Science, Psychology and a Minor in Sociology. Since then I have continued my reach for knowledge by furthering my front End development skills, where I found how to combine my creativity with coding. This webpage is a testament of my capabilities, with everything from code scripting to graphics is all of my own creation.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container className="about-Me-Sec img-Sec-Height background-Still" fluid />
            <Container className="sec-padding" fluid>
                <Row className="reversed-row">
                    <Col className="m-auto" md>
                        <Image src={Moonoz} className="about-Me-Moonoz d-block mx-auto" />

                    </Col>
                    <Col className="sec-Text-Right margin-auto align-items-center" md>
                        <h1 className="right-text">
                            I'm Moonoz Disenoz
                        </h1>
                        <p class="about-Me-Text">
                            After hours I love to dig into my imagination and create stunning art pieces. I began my own Graphic Design freelance service called "Moonoz Disenoz", where I transform visions into visual arts for all to enjoy. I draw inspiration from my favorite childhood cartoons like Disney (I’m a big Disney fan). Be sure to check out my Disenoz page and Instagram to see some of my works.
                        </p>

                    </Col>
                </Row>
            </Container>
        </Container >
    );
}

export default aboutMe;